// extracted by mini-css-extract-plugin
export default {"container":"loading_container__R+cBo","loader":"loading_loader__JXob7","spin":"loading_spin__X9Z3Q","loadingText":"loading_loadingText__JG2At"};